import { getBlob, getJob, publishVersion, setBlob } from "./endpoints";

export {
  AgentVersionDetails,
  AssetVersionDetails,
  EvalVersionDetails,
  PresetVersionDetails,
} from "./details";

export {
  CATALOG_JOB_STEPS,
  CATALOG_SINGLE_UPLOAD_MAX_BYTES,
  CATALOG_UPLOAD_PART_BYTES,
  CatalogJob,
  type CatalogJobStep,
  CatalogKind,
  CatalogProblem,
  CatalogUpload,
  PublishCatalogVersionRequest,
  PublishCatalogVersionResponse,
  PutCatalogBlobRequest,
  PutCatalogBlobResponse,
} from "./schemas";

export const contract = {
  blobs: { get: getBlob, set: setBlob },
  versions: { publish: publishVersion },
  jobs: { get: getJob },
} as const;
